import React, { useId } from 'react';

const isDev = process.env.NODE_ENV !== 'production';

export default function ChartA11y({ title, desc, width, height, className, style, children, ...rest }) {
  if (isDev && (!title || typeof title !== 'string' || !title.trim())) {
    throw new Error(
      'ChartA11y: `title` prop is required and must be a non-empty string. ' +
        'Every viz component must declare its accessible name. See PRD-69 §3.2.0.'
    );
  }

  const reactId = useId();
  const titleId = `${reactId}-title`;
  const descId = desc ? `${reactId}-desc` : undefined;
  const labelledBy = descId ? `${titleId} ${descId}` : titleId;

  return (
    <svg
      role="img"
      aria-labelledby={labelledBy}
      width={width}
      height={height}
      className={className}
      style={style}
      {...rest}
    >
      <title id={titleId}>{title}</title>
      {desc ? <desc id={descId}>{desc}</desc> : null}
      {children}
    </svg>
  );
}
